import { render, staticRenderFns } from "./CreatePostcard.vue?vue&type=template&id=190ed341&"
import script from "./CreatePostcard.vue?vue&type=script&lang=js&"
export * from "./CreatePostcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports